import { render, staticRenderFns } from "./globalTag.vue?vue&type=template&id=9ee69644&scoped=true&"
import script from "./globalTag.vue?vue&type=script&lang=js&"
export * from "./globalTag.vue?vue&type=script&lang=js&"
import style0 from "./globalTag.vue?vue&type=style&index=0&id=9ee69644&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee69644",
  null
  
)

export default component.exports